/*
 * @Author: wxb
 * @Date: 2023-02-14 22:27:28
 * @LastEditTime: 2023-02-14 22:35:43
 * @FilePath: \admin\src\utils\index.js
 */
import swal from 'sweetalert2';
import axios from 'axios'
import store from '../store'
const success = ({ text: text, url: url }) => {
	text = text || '操作成功';
	swal({
		title: text,
		type: 'success',
		confirmButtonColor: '#4aa6fc',
		confirmButtonText: '确定'
	}).then(function (isConfirm) {
		if (isConfirm.value == true && url) {
			router.push(url);
		}
	});
};
const error = (text1, text2, type) => {
	type = type || 'error';
	swal({
		title: text1,
		text: text2,
		type: type,
		confirmButtonColor: '#4aa6fc',
		confirmButtonText: '确定'
	});
};
const phptime = function (time) {
	if (time == null || time == "" || time == undefined) {
		return "";
	}
	var mytime = time.toString();
	var pt = mytime.substring(0, mytime.length - 3);
	return pt;
};

const getTimeFormat = function (time, hs) {
	//time 1398250549490
	//时间数字转2014-04-23 18:55:49 格式
	// php 后端时间戳返回10位数，补3个 000
	if (
		time == '0' ||
		time == '0000' ||
		time == '' ||
		time == 'null' ||
		time == null ||
		time == 'undefined' ||
		isNaN(time)
	) {
		return '~~';
	}
	time = time + '';
	var date = '';
	if (time.length >= 13) {
		date = new Date(parseInt(time));
	} else {
		date = new Date(parseInt(time + '000'));
	}
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	var s = ':' + (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	if (hs == undefined) {
		return Y + M + D + ' ' + h + m;
	} else if (hs == 'md') {
		return M.replace('-', '月') + D + '日';
	} else if (hs == 'ymd') {
		return Y + M + D;
	} else if (hs == 'hms') {
		return h + m + s;
	} else if (hs == 'ymdhms') {
		return Y + M + D + ' ' + h + m + s;
	} else if (hs == 'ym') {
		return Y.replace('-', '年') + M.replace('-', '月');
	} else {
		return h + m;
	}
};
const convertBase64UrlToBlob = function (urlData) {
	let bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
	//处理异常,将ascii码小于0的转换为大于0
	let ab = new ArrayBuffer(bytes.length);
	let ia = new Uint8Array(ab);
	for (var i = 0; i < bytes.length; i++) {
		ia[i] = bytes.charCodeAt(i);
	}
	return new Blob([ab], {
		type: "image/png",
	});
};

const Base64Uploadimg = function (baseStr, is_tip = true) {
	return new Promise((resove, reject) => {
		let file = convertBase64UrlToBlob(baseStr);
		var fd = new FormData();
		fd.append("file", file, "file_" + Date.parse(new Date()) + ".jpg");
		// fd.append("folder", 'product');

		let config = {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		};
		axios.post("https://petapi.asia/upload", fd, config).then((res) => {
			// Toast.clear();
			if (res.data.url) {
				// is_tip && Toast.success("上传成功");
				resove(res.data);
			} else {
				// is_tip && Toast.fail("上传失败");
				reject(false);
			}
		});
	});
};
const downImg = (src) => {
	let image = new Image();
	// 解决跨域 Canvas 污染问题
	image.setAttribute("crossOrigin", "anonymous");
	image.onload = function () {
		let canvas = document.createElement("canvas");
		canvas.width = image.width;
		canvas.height = image.height;
		let context = canvas.getContext("2d");
		context.drawImage(image, 0, 0, image.width, image.height);
		let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
		let a = document.createElement("a"); // 生成一个a元素
		let event = new MouseEvent("click"); // 创建一个单击事件
		a.download = name || "photo"; // 设置图片名称
		a.href = url; // 将生成的URL设置为a.href属性
		a.dispatchEvent(event); // 触发a的单击事件
	};
	image.src = src;
}
const getImgUrl = function (url) {
	if (url == "" || url == undefined) {
		return require("../assets/productDefault.jpg");
	}
	 if (url.indexOf("http") >= 0) {
		return url;
	} else {
		return store.state.baseUrl + url;
	}
};
export default {
	success,
	error,
	getTimeFormat,
	downImg,
	Base64Uploadimg,
	phptime,
	getImgUrl
};
